import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
export function TermsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-navy text-white/90 font-sans selection:bg-violet-electric/30" data-id="element-1967" data-mp="25awaljcomc5j">
      {/* Hero Section */}
      <section id="hero" className="relative pt-32 pb-16 px-6" data-id="element-1968" data-mp="2f790e653w5v0">
        <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-1969" data-mp="2f5xvg2zxcs2b">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-1970" data-mp="2t5yy9nzr29kf">

            <span className="text-violet-electric text-sm font-semibold tracking-widest uppercase mb-6 block" data-id="element-1971" data-mp="32x3eer15w0gu">
              Legal
            </span>
            <h1 className="text-4xl md:text-5xl font-bold leading-tight tracking-tight mb-6 bg-clip-text text-transparent bg-gradient-to-b from-white to-white/70" data-id="element-1972" data-mp="2xztn15u7peqd">
              Terms & Privacy
            </h1>
            <p className="text-white/50 text-base" data-id="element-1973" data-mp="2vn7gxf8fqfir">
              Last Updated: September 3, 2024
            </p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <article className="relative z-10 max-w-3xl mx-auto px-6 pb-32" data-id="element-1974" data-mp="2zqvrm6sd5r88">
        <div className="prose prose-invert prose-lg max-w-none prose-headings:text-white prose-headings:font-bold prose-p:text-white/80 prose-p:leading-relaxed prose-strong:text-white prose-li:text-white/80" data-id="element-1975" data-mp="34mb16mjc90yu">
          {/* EULA */}
          <section id="eula" data-id="element-1976" data-mp="3ek8xlxbcq42j">
            <h2 className="text-3xl mt-8 mb-8" data-id="element-1977" data-mp="3in5enjl8ts4d">
              End User License Agreement (EULA)
            </h2>

            <p data-id="element-1978" data-mp="3nfewsdg49nw3">
              This End User License Agreement ("Agreement") is a legal agreement
              between you ("Licensee" or "you") and Redshift Enterprises
              ("Licensor" or "we") regarding your use of Thruline ("Software").
              By installing, copying, or otherwise using the Software, you agree
              to be bound by the terms of this Agreement.
            </p>

            <h3 className="text-xl font-semibold text-white mt-10 mb-4" data-id="element-1979" data-mp="3coabbq3n6ejy">
              1. License Grant
            </h3>

            <p data-id="element-1980" data-mp="37q8tf8hycla2">
              <strong data-id="element-1981" data-mp="37mkxk2p1bms6">1.1 License:</strong> Subject to the terms and conditions
              of this Agreement, Licensor grants you a non-exclusive,
              non-transferable, limited license to install and use the Software
              on a single device for personal or internal business purposes.
            </p>

            <p data-id="element-1982" data-mp="3qf5mj91m57qp">
              <strong data-id="element-1983" data-mp="3qfovi09aclsl">1.2 Restrictions:</strong> You may not:
            </p>
            <ul className="space-y-2 pl-6 list-disc marker:text-violet-electric/50" data-id="element-1984" data-mp="96s6zsn2vpoa">
              <li data-id="element-1985" data-mp="94fo9d9hxba6">
                Modify, adapt, translate, or create derivative works based on
                the Software.
              </li>
              <li data-id="element-1986" data-mp="2az6judarm3xu">
                Reverse engineer, decompile, disassemble, or attempt to derive
                the source code of the Software.
              </li>
              <li data-id="element-1987" data-mp="lh9nucdcsznv">
                Redistribute, sell, rent, lease, or sublicense the Software to
                any third party.
              </li>
              <li data-id="element-1988" data-mp="qfkxalzql85k">
                Remove, alter, or obscure any proprietary notices on the
                Software.
              </li>
            </ul>

            <h3 className="text-xl font-semibold text-white mt-10 mb-4" data-id="element-1989" data-mp="gq1ethfxrgb8">
              2. Intellectual Property Rights
            </h3>

            <p data-id="element-1990" data-mp="2pqnkdaprzpj">
              <strong data-id="element-1991" data-mp="2p8g0kilpz2b">2.1 Ownership:</strong> The Software and all related
              materials are protected by intellectual property laws and
              treaties. Licensor retains all rights, title, and interest in and
              to the Software, including all intellectual property rights
              therein.
            </p>

            <p data-id="element-1992" data-mp="1n6mvkl1h432h">
              <strong data-id="element-1993" data-mp="1n63o5y9g8x2p">2.2 Trademarks:</strong> All trademarks, service marks,
              logos, and trade names associated with the Software are the
              property of Licensor or its licensors.
            </p>

            <h3 className="text-xl font-semibold text-white mt-10 mb-4" data-id="element-1994" data-mp="3o7bazsb32ahn">
              3. Limitation of Liability
            </h3>

            <p data-id="element-1995" data-mp="3j7f49lb044ye">
              <strong data-id="element-1996" data-mp="3f7wm2xake7z9">3.1 Disclaimer:</strong> The Software is provided "AS IS"
              without warranty of any kind, either express or implied, including
              but not limited to the implied warranties of merchantability,
              fitness for a particular purpose, and non-infringement.
            </p>

            <p data-id="element-1997" data-mp="30ii9lgbozafn">
              <strong data-id="element-1998" data-mp="30hz3qxzbgchz">3.2 Limitation:</strong> To the maximum extent permitted
              by applicable law, in no event shall Licensor be liable for any
              special, incidental, indirect, or consequential damages whatsoever
              arising out of the use of or inability to use the Software.
            </p>

            <h3 className="text-xl font-semibold text-white mt-10 mb-4" data-id="element-1999" data-mp="2mihao6ezmd2t">
              4. Termination
            </h3>

            <p data-id="element-2000" data-mp="2hmigg26za0uh">
              <strong data-id="element-2001" data-mp="x2dn9qbr233h">4.1 Termination by Licensor:</strong> Licensor may
              terminate this Agreement at any time if you fail to comply with
              any term or condition of this Agreement.
            </p>

            <p data-id="element-2002" data-mp="1701i0g9cvaln">
              <strong data-id="element-2003" data-mp="171mdq97eozl3">4.2 Effect of Termination:</strong> Upon termination, you
              must cease all use of the Software and destroy all copies of the
              Software in your possession or control.
            </p>

            <h3 className="text-xl font-semibold text-white mt-10 mb-4" data-id="element-2004" data-mp="edgopa9bkofg">
              5. Governing Law
            </h3>

            <p data-id="element-2005" data-mp="ncbxmu3r0cmg">
              This Agreement shall be governed by and construed in accordance
              with the laws of the applicable jurisdiction, without regard to
              its conflict of law principles.
            </p>

            <h3 className="text-xl font-semibold text-white mt-10 mb-4" data-id="element-2006" data-mp="3rrboaa12tz7z">
              6. Miscellaneous
            </h3>

            <p data-id="element-2007" data-mp="3vqkjzkfog766">
              <strong data-id="element-2008" data-mp="3vqaq3lrihfv7">6.1 Severability:</strong> If any provision of this
              Agreement is found to be invalid or unenforceable, the remaining
              provisions shall remain in full force and effect.
            </p>

            <p data-id="element-2009" data-mp="1cn6x9orukhbe">
              <strong data-id="element-2010" data-mp="1cnq347483f92">6.2 Entire Agreement:</strong> This Agreement constitutes
              the entire agreement between you and Licensor with respect to the
              Software and supersedes all prior or contemporaneous
              understandings or agreements.
            </p>

            <p data-id="element-2011" data-mp="ezy4r9tfi7zw">
              <strong data-id="element-2012" data-mp="f0homw2n36gk">6.3 Amendments:</strong> Licensor reserves the right to
              modify this Agreement at any time, and such modifications will be
              effective upon notice to you.
            </p>

            <p className="text-white/60 text-sm uppercase tracking-wide mt-8 p-4 rounded-xl border border-white/[0.06] bg-white/[0.02]" data-id="element-2013" data-mp="ox2tnhenshke">
              By installing or using the Software, you acknowledge that you have
              read this Agreement, understand it, and agree to be bound by its
              terms and conditions.
            </p>
          </section>

          <hr className="border-white/10 my-16" data-id="element-2014" data-mp="2cw6amy89u1iu" />

          {/* Privacy Policy */}
          <section id="privacy" data-id="element-2015" data-mp="1xydzei9rbzag">
            <h2 className="text-3xl mt-16 mb-8" data-id="element-2016" data-mp="1xzflriw8487h">Privacy Policy</h2>

            <p data-id="element-2017" data-mp="22x7ak41kne7g">
              This Privacy Policy applies to your use of our website, which
              includes our subscription services (our "Service") and our
              software ("Software").
            </p>

            <h3 className="text-xl font-semibold text-white mt-10 mb-4" data-id="element-2018" data-mp="2vme7wzpahxr4">
              1. Information We Collect
            </h3>

            <p data-id="element-2019" data-mp="2gwp3mvlwhdmm">We collect information in two ways:</p>

            <p data-id="element-2020" data-mp="2lvtd7ncqlddh">
              <strong data-id="element-2021" data-mp="2lvjos47cbe9w">Information you give us.</strong> For example, some of our
              Services require you to log-in and create an account. When you
              set-up an account, we'll ask you for personal information (more
              fully defined below), like your name, email address, telephone
              number and your credit card number, if necessary.
            </p>

            <p data-id="element-2022" data-mp="19jedqamnenbm">
              <strong data-id="element-2023" data-mp="19ild7rea8u1x">Information we get from your use of our Services.</strong>{' '}
              We may collect information about the Services that you use and how
              you use them, like when you visit our website. This information
              includes:
            </p>

            <ul className="space-y-2 pl-6 list-disc marker:text-violet-electric/50" data-id="element-2024" data-mp="1x9iiwmfhiv4q">
              <li data-id="element-2025" data-mp="1t73yvz02xpbv">
                <strong data-id="element-2026" data-mp="1t8osnmekl48o">Device Information</strong> — we may collect
                device-specific information (such as your hardware model,
                operating system version, unique device identifiers, and mobile
                network information including phone number). We may associate
                your device identifiers or phone number with your account.
              </li>
              <li data-id="element-2027" data-mp="7u14tymsldvf">
                <strong data-id="element-2028" data-mp="7tj3wop6qbh6">Log information</strong> — when you use our Services or
                view content that we provide, we may automatically collect and
                store certain information in server logs. This may include
                details of how you used our Services, such as your search
                queries, Internet protocol address, and device event information
                such as crashes or other system activity.
              </li>
              <li data-id="element-2029" data-mp="ghd8m92hs5mo">
                <strong data-id="element-2030" data-mp="gfttilsko0mh">Location information</strong> — when you agree to use a
                location-enabled service, we may collect and process information
                about your exact location.
              </li>
              <li data-id="element-2031" data-mp="qfkmuk5ec9kz">
                <strong data-id="element-2032" data-mp="qcyewjelfs28">Local storage</strong> — we may collect and store
                information locally on your device using mechanisms such as
                browser web storage and application data caches.
              </li>
            </ul>

            <p data-id="element-2033" data-mp="2x4pkg5fu27ma">
              "Personal information" means information that specifically
              identifies you, including but not limited to your name, address,
              telephone number, email address and credit card information.
            </p>

            <p data-id="element-2034" data-mp="ufesir5qs6xn">
              <strong data-id="element-2035" data-mp="yff5s8h3uc34">Cookies.</strong> In order to improve our Service and
              provide a more relevant experience to our users, we may collect
              information using "cookies." Cookies are small data files stored
              on your hard drive by a website. We may use cookies to see which
              areas and features are popular and to count visits to our Service.
              Most web browsers are set to accept cookies by default. If you
              prefer, you can usually choose to set your browser to remove
              and/or reject cookies. If we use cookies and you choose to remove
              or reject them, this could affect certain features of our Service.
            </p>

            <p data-id="element-2036" data-mp="1w24jhfl66d4t">
              <strong data-id="element-2037" data-mp="1w3pdn43knu25">Third Party Cookies.</strong> We may also allow third
              parties, such as Google, to use cookies on our Service. Such third
              party cookies are used to help recognize your log-in status and
              permit you to access third party features enabled through our
              Service and to evaluate and compile aggregated statistics about
              activity on our Service. You can usually choose to set your
              browser to remove and/or reject these cookies, but note that doing
              so could affect certain features of our Service.
            </p>

            <p data-id="element-2038" data-mp="2jz101342vg6d">
              Our Service may require you to use the most current version of the
              Software. The Software may automatically check to determine if you
              are using the most current version of the Software. During this
              process, an IP address identifying your computer, operating system
              version and the Software version may be collected via the
              Internet.
            </p>

            <p data-id="element-2039" data-mp="10z1l7syz2tor">
              We may on occasion supplement the personal information you submit
              to us with information from third-party sources. For example, if
              permitted under applicable law, we may supplement the information
              you provide when you register for an account with address
              information provided by the U.S. Postal Service to verify your
              information and prevent errors in our database.
            </p>

            <h3 className="text-xl font-semibold text-white mt-10 mb-4" data-id="element-2040" data-mp="n7wr16editlt">
              2. How We Use the Information We Collect
            </h3>

            <p data-id="element-2041" data-mp="8cgr4kr443hi">
              In general, we use personal information we collect for the
              purposes described in this Privacy Policy or otherwise disclosed
              to you through our Service. For example, we may use your
              information:
            </p>

            <ul className="space-y-2 pl-6 list-disc marker:text-violet-electric/50" data-id="element-2042" data-mp="27myq6y74yvb1">
              <li data-id="element-2043" data-mp="3s5alaj5thh5n">To provide and improve the Service and the Software;</li>
              <li data-id="element-2044" data-mp="3n6zdsf2zviql">
                To send you a welcome email and contact you about your use of
                the Service or Software (e.g., for administrative and customer
                service purposes);
              </li>
              <li data-id="element-2045" data-mp="zhmc0a5hou5">
                To process your requests or transactions and to send you related
                information, including confirmations, invoices, technical
                notices, updates, security alerts and support and administrative
                messages;
              </li>
              <li data-id="element-2046" data-mp="opljppwqwscp">
                To provide you with information, products or services you
                request;
              </li>
              <li data-id="element-2047" data-mp="jr1w7l2i78i8">
                To track customer preferences and inform you about product
                upgrades, special offers and products and our services that we
                think will be of interest to you;
              </li>
              <li data-id="element-2048" data-mp="2mzao7vzmevom">
                To respond to your emails, submissions, feedback, bug reports,
                requests for new features, help requests or other comments,
                questions or complaints;
              </li>
              <li data-id="element-2049" data-mp="2wy9xngs7mvco">
                To monitor and analyze usage, trends and activities in
                connection with the Service and Software;
              </li>
              <li data-id="element-2050" data-mp="248taaxjg64nb">
                To automatically determine if you are using the most current
                version of the Software and to send you email messages, and
                potentially a pop-up box or similar notification mechanisms to
                inform you if you need to upgrade in order to use the Service
                you have requested.
              </li>
            </ul>

            <h3 className="text-xl font-semibold text-white mt-10 mb-4" data-id="element-2051" data-mp="1libmn7dh1z8t">
              3. Sharing of Personal Information
            </h3>

            <p data-id="element-2052" data-mp="1qfbrxg2hyxyv">
              We do not share your personal information with third parties other
              than as follows:
            </p>

            <ul className="space-y-2 pl-6 list-disc marker:text-violet-electric/50" data-id="element-2053" data-mp="3kgb8v823drd">
              <li data-id="element-2054" data-mp="3ic5e7qlk4og">
                When you give us your consent to do so, including if we notify
                you through the Service that the information you provide will be
                shared in a particular manner and you provide such information;
              </li>
              <li data-id="element-2055" data-mp="3ktlhp958u5dq">
                With third party vendors, consultants and service providers who
                perform functions on our behalf, but we limit their use of the
                information as is reasonably necessary to carry out their work;
              </li>
              <li data-id="element-2056" data-mp="3726sulonn9yr">
                When we believe in good faith that we are lawfully authorized or
                required to do so or that doing so is reasonably necessary or
                appropriate to comply with laws or respond to lawful requests,
                legal process or legal authorities;
              </li>
              <li data-id="element-2057" data-mp="2nh6pqqupbiil">
                When we believe in good faith that doing so is reasonably
                necessary or appropriate to protect our rights, property or
                safety or that of our employees, agents, users or others,
                including to enforce our agreements and policies or to enforce
                our Terms of Use including investigation of potential violations
                of our Terms of Use;
              </li>
              <li data-id="element-2058" data-mp="3b3mx3rb28hr6">
                In extraordinary circumstances, such as to respond to an
                emergency or for reasons of national security, an urgent matter
                of public or individual safety or other issues of dire
                importance;
              </li>
              <li data-id="element-2059" data-mp="3p47d6fplbzgz">
                In connection with, or during negotiations of, a merger,
                consolidation, sale of our corporate assets or equity,
                financing, acquisition, corporate reorganization, strategic
                alliance or in any other similar situation where personal
                information may be transferred as one of our business assets;
              </li>
              <li data-id="element-2060" data-mp="1s4yqquachr70">
                If you post information to our bulletin board or blog
                (collectively, "Public Forums"), such information, along with
                your email address, will be publicly available to all persons
                accessing that Public Forum. We are not responsible for any
                information you submit to a Public Forum or the subsequent use
                of such information by third parties.
              </li>
            </ul>

            <p data-id="element-2061" data-mp="14g5zvc8ky9j9">
              We may also share aggregated or other data that does not directly
              identify you.
            </p>

            <h3 className="text-xl font-semibold text-white mt-10 mb-4" data-id="element-2062" data-mp="2kws6ylqemco7">
              4. Your Choices with Respect to Personal Information
            </h3>

            <p data-id="element-2063" data-mp="d9p4az0ow15k">
              We may send information to you regarding our products, services
              and special offers or those of selected third parties, unless you
              have opted not to receive such communications or such
              communications are prohibited by law. If you do not wish to
              receive such email, regular mail or other messages, you may opt
              out at the time of registration or information collection by
              logging into your account settings and updating your contact
              preferences.
            </p>

            <p data-id="element-2064" data-mp="15x2zosoqoonk">
              Please note that even if you opt out of receiving email or other
              communications from us, we may find it necessary to continue to
              communicate with you regarding your use of the Service or the
              Software, such as messages related to transactions or services you
              have specifically requested, in response to any email from you to
              us, to notify you of updates or changes to our policies and
              procedures, or to otherwise provide you with information we
              believe is important to users. Our systems may require time to
              update, so your opt-out requests may not be updated immediately.
            </p>

            <h3 className="text-xl font-semibold text-white mt-10 mb-4" data-id="element-2065" data-mp="2qh6tscrvrl32">
              5. Protection of Your Personal Information
            </h3>

            <p data-id="element-2066" data-mp="3j4b0qnaja9hh">
              We take all reasonable measures to help protect your personal
              information in an effort to prevent loss, misuse and unauthorized
              access, disclosure, alteration and destruction.
            </p>

            <h3 className="text-xl font-semibold text-white mt-10 mb-4" data-id="element-2067" data-mp="395lk0xudiv2t">
              6. Third Party Links
            </h3>

            <p data-id="element-2068" data-mp="22nyhovu723fl">
              The Service may contain links to other websites at which personal
              information is collected. This Privacy Policy does not apply to
              linked sites and we are not responsible for the content or privacy
              and security practices of those sites. Any personal information
              you provide to a linked site is provided directly to a third party
              and is subject to such third party's privacy policy. We encourage
              you to learn more about such third parties' privacy and security
              practices and policies before providing them with any personal
              information.
            </p>

            <h3 className="text-xl font-semibold text-white mt-10 mb-4" data-id="element-2069" data-mp="1bh5sn0n548db">
              7. Changes in Privacy Policy
            </h3>

            <p data-id="element-2070" data-mp="12iu2t0u3lelx">
              As the need arises, we may change this Privacy Policy at any time.
              We will provide notice of changes to our Privacy Policy by
              indicating on the Policy the date it was last updated and making
              the updated Privacy Policy available through our website. Your use
              of the Service or Software following the posting of the updated
              Privacy Policy constitutes your consent to all changes. We
              encourage you to review this Privacy Policy whenever you access or
              use our Service or Software to make sure you understand how
              personal information we collect may be used or disclosed.
            </p>

            <h3 className="text-xl font-semibold text-white mt-10 mb-4" data-id="element-2071" data-mp="2lg6x7ar7rr3w">
              8. Contacting Us
            </h3>

            <p data-id="element-2072" data-mp="2qerxfa6guasc">
              If you have any questions or comments about this Privacy Policy or
              our practices relating to the Service or Software, or if you
              believe we have not complied with this Privacy Policy, please
              contact us at{' '}
              <a href="mailto:contact@thruline.co" className="text-violet-electric hover:underline" data-id="element-2073" data-mp="10574gqkj4v7h">

                contact@thruline.co
              </a>
              .
            </p>
          </section>
        </div>
      </article>
    </div>;
}